export default __webpack_public_path__ + "static/media/1983.35f877e7.png";